export default "/assets/images/spring-background-sm.webp?059073c70416b77ad6b7858e1f545cc0";